import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { StockControlRow } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import StockControlTableBody from './StockControlTableBody';

interface StockControlTableProps {
    rows: StockControlRow[];
    showSpinner: boolean;
    order: string;
    desc: boolean;
    onOrder: (field: string, desc: boolean) => void;
    onOpen: (row: StockControlRow) => void;
    showCategory: boolean;
    showArticle: boolean;
}

const StockControlTable = ({
    rows,
    showSpinner,
    order,
    desc,
    onOrder,
    onOpen,
    showCategory,
    showArticle,
}: StockControlTableProps) => {
    const { t } = useTranslation(['Warehouses']);
    const tableMinWidth = 350 + (showCategory ? 160 : 0) + (showArticle ? 150 : 0);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="StockControlTable table-hover" style={{ minWidth: tableMinWidth }}>
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('fields.prodName')}
                                    onClick={onOrder}
                                    value={order}
                                    desc={desc}
                                    fieldName="prod_name"
                                />
                            </td>
                            {showCategory ? (
                                <td className="head-category">
                                    <TableHeadTdOrder
                                        title={t('fields.category')}
                                        onClick={onOrder}
                                        value={order}
                                        desc={desc}
                                        fieldName="category_name"
                                    />
                                </td>
                            ) : null}
                            {showArticle ? (
                                <td className="head-article">
                                    <TableHeadTdOrder
                                        title={t('fields.article')}
                                        onClick={onOrder}
                                        value={order}
                                        desc={desc}
                                        fieldName="prod_article"
                                    />
                                </td>
                            ) : null}
                            <td className="head-count">
                                <TableHeadTdOrder
                                    title={t('fields.countEnd')}
                                    onClick={onOrder}
                                    value={order}
                                    desc={desc}
                                    className="cursor-pointer d-flex align-items-center justify-content-center"
                                    fieldName="stock_count"
                                />
                            </td>
                        </tr>
                    </thead>
                    <StockControlTableBody
                        rows={rows}
                        onOpen={onOpen}
                        showCategory={showCategory}
                        showArticle={showArticle}
                    />
                </Table>
            </div>
        </div>
    );
};

export default StockControlTable;
